import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { forkJoin, map, Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { RootState } from '../../../../core/stores/store';
import { selectToolbarIcon, selectToolbarTitle } from '../../../../core/stores/app/app.selectors';
import { CommonModule } from '@angular/common';
import { UserActions } from '../../../../core/stores/user/user.actions';
import { MatMenuModule } from '@angular/material/menu';
import { selectCurrentUserDealerName, selectCurrentUserName, selectUserDealers } from '../../../../core/stores/user/user.selectors';
import { UserDealer } from '../../../../shared/interfaces/user.interfaces';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../../../../core/local-services/permission.service';

@Component({
  selector: 'app-toolbar',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    RouterModule,
    TranslateModule
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss'
})

export class ToolbarComponent implements OnInit, OnDestroy {

  toolbarTitle$: Observable<string | undefined>;
  toolbarIcon$: Observable<string | undefined>;
  currentUserDealerName$: Observable<string | undefined>;
  currentUserDealers$: Observable<UserDealer[] | undefined>
  currentUserDealers: UserDealer[] = [];
  private dealersSubscription?: any;
  currentUserName$: Observable<string | undefined>;
  currentNavIcon: string = 'dashboard'

  constructor(
    private store: Store<RootState>,
    private translateService: TranslateService,
    public permissionService: PermissionService
  ) {
    this.toolbarTitle$ = this.store.select(selectToolbarTitle);
    this.toolbarIcon$ = this.store.select(selectToolbarIcon);
    this.currentUserDealerName$ = this.store.select(selectCurrentUserDealerName);
    this.currentUserDealers$ = this.store.select(selectUserDealers);
    this.currentUserName$ = this.store.select(selectCurrentUserName),
      this.translateService.setDefaultLang('en');
    this.translateService.use(this.translateService.getBrowserLang() || 'en');
  }

  ngOnInit(): void {
    this.store.dispatch(UserActions.loadUserDealers());
    this.dealersSubscription = this.currentUserDealers$.subscribe(dealers => {
      if (dealers) {
        this.currentUserDealers = dealers;
        // Optional reordering of dealers by ID (comment above and uncomment below to change order)
        // this.currentUserDealers = [...dealers].sort((a, b) => a.id - b.id);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.dealersSubscription) {
      this.dealersSubscription.unsubscribe();
    }
  }

  changeUserDealer(usersDealersId: number): void {
    return this.store.dispatch(UserActions.changeUserDealer({ usersDealersId: usersDealersId }))
  }

  logout(): void {
    this.store.dispatch(UserActions.unsetUser());
  }

  changeNavIcon(icon: string): void {
    this.currentNavIcon = icon;
  }

  hasAnyAdvancedReadPermission(): Observable<boolean> {
    const permissions = [
      'readEventDefinitions',
      'readEventProtocols',
      'readClickCommands',
      'readClickTemplates',
      'updateDealerSkin',
      'listApiKeys',
      'listWebhooks',
      'readForwarders'
    ];
    if (permissions.length === 0) {
      return new Observable<boolean>(observer => { observer.next(false); observer.complete(); });
    }
    return forkJoin(
      permissions.map(permission => this.permissionService.isAllowed(permission))
    ).pipe(
      map((results: boolean[]) => results.some(Boolean))
    );
  }

}
